// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getSearchResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';
import {updateShowPartialDataWarning} from './partial-data-warning';

export const readProductsByCustomer = ckcId =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const products = await getSearchResults(ckcId, 'CUSTOMER');

            const partialData = products.some(product => product.httpStatus === '206');

            dispatch({
                products,
                type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS
            });

            updateShowPartialDataWarning(partialData)(dispatch);

            if (!getState().exportToExcel.selectedExcelLayout.productSearch.name) {

                readExcelLayouts('productSearch')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/read-products-by-customer.js